
import React from 'react';
import { Suspense } from 'react';
import {Router,Route} from './modules/wrap-redux/index'; //Router为BrowserRouter
import {render} from "@modules/wrap-redux/index";
import "./defineWrapRedux";
// import PageIndex from './PageIndex';
// import PageManual from './PageManual';
// import PageSet from './PageSet';
const PageIndex = React.lazy(() => import('./PageIndex'));
const PageManual = React.lazy(() => import('./PageManual'));
const PageSet = React.lazy(() => import('./PageSet'));
import './index.scss';
import '@modules/global.conf';

const events = require('events');
const eventEmitter = new events.EventEmitter();

if(window._SOURCE === "ganji"&&window.WBAPP&&window.WBAPP.action&&window.WBAPP.action.toast){
    window.alert= window.WBAPP.action.toast;
}

//import * as serviceWorker from './serviceWorker';
window.____globalCommonObjforFE = {};//存放一些全局用的变量  比如图方便有些组件通信没用redux 用的events。。(主要还是由于wrap-redux处于完善期 所以非主交互 就没用 别打我)
window.____globalCommonObjforFE.eventEmitter = eventEmitter;
// render(
//     <Router>
//         <div>
//             <Route exact path="/mcommonchat" component= {PageIndex}></Route>
//             <Route exact path="/mcommonchat/manual" component= {PageManual}></Route>
//             <Route exact path="/mcommonchat/set" component= {PageSet}></Route>
//         </div>
//     </Router>, document.getElementById('root'));
render(
    <Suspense fallback={<div></div>}>
        <Router>
            <div>             
                <Route exact path="/mcommonchat" component= {(props) => <PageIndex {...props} />}></Route>
                <Route exact path="/mcommonchat/manual" component= {(props) => <PageManual {...props} />}></Route>
                <Route exact path="/mcommonchat/set" component= {(props) => <PageSet {...props} />}></Route>
            </div>
        </Router>
  </Suspense>, document.getElementById('root'));

// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: http://bit.ly/CRA-PWA
// //serviceWorker.unregister();